import { render, staticRenderFns } from "./AbsencePlans.vue?vue&type=template&id=2fab0591&"
import script from "./AbsencePlans.vue?vue&type=script&lang=js&"
export * from "./AbsencePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports